// extracted by mini-css-extract-plugin
export default {"btns":"AC_btns__op4Gn"};